import propTypes from 'prop-types';
import React from 'react';
import * as theme from '../constants/theme';

const Section = ({children, ...props}) => (
	<div {...props}>
		{children}
		<style jsx>
			{`
				div {
					padding: calc(${theme.GUTTER} * 2) 0;
				}
			`}
		</style>
	</div>
);

Section.propTypes = {
	children: propTypes.any
};

export default Section;



// WEBPACK FOOTER //
// components/section.js